import React from 'react';
import Button from '../../../../components/button';
import Badge from '../../../../components/badge';

import { VitalItemFooterSC } from './vital-list.styled';
import { BadgeTypes } from '../../../../components/badge/badge';

type TVitalItemFooterProps = {
  onDetailOpen?: () => void;
  badgeType: BadgeTypes;
  skipBadgeTranslation: boolean;
  badgeText: string;
  isEmpty?: boolean;
};

const VitalItemFooter: React.FC<TVitalItemFooterProps> = (props: TVitalItemFooterProps) => {
  const { onDetailOpen } = props;
  return (
    <VitalItemFooterSC hasDetail={onDetailOpen !== undefined}>
      <Button size="SM" text="life_id.detail" onClick={onDetailOpen} disabled={props.isEmpty} />
      {props.isEmpty ? null : (
        <Badge
          text={props.badgeText}
          type={props.badgeType}
          skipTranslation={props.skipBadgeTranslation}
        />
      )}
    </VitalItemFooterSC>
  );
};

export default VitalItemFooter;
